import { useContext } from "react";
import { ConfigurationContext } from "contexts";

// Only run if the current step is shown.
// const shouldRun = (config) => {
//   try {
//     return config.steps.speedTestDetection;
//   } catch (error) {
//     return false;
//   }
// };

export const useSpeedTestDetection = (onProgress, onDone) => {
  let config = useContext(ConfigurationContext);

  const run = () => {
    // Configure the host.
    var subDomain = window.location.hostname
      .toLowerCase()
      .replace(".systemrequirementslab.com", "");
    if (
      subDomain !== "test.cyri" &&
      subDomain !== "prod.cyri" &&
      subDomain !== "www"
    ) {
      subDomain = "www";
    }

    // Set the detection settings.
    window.SRL.detection.init({
      loggingLevel: 2,
      host: subDomain, //window.location.hostname.toLowerCase().replace(".systemrequirementslab.com",""),
      // host: "www",
      protocol: "https",
      referrerId: config.referrerId,
      onProgress: onProgress,
      // onError: onError,
      onDone: onDone,
      scanSpeedTest: true,
      speedTestContainer: "speed-test",
      scanNetworkLatency: false, // Don't run the network scan.
      scanNetworkSpeed: false, // Don't run the network scan.
      networkScanTimeout: 90000,
      computerId: config.computerId,
    });

    // Run the detection.
    window.SRL.detection
      .runNetworkScan()
      .then(() => {
        console.log("Speed test detection is done.");
      })
      .catch((error) => {
        console.log("Caught error: " + error.message);
      });
  };
    
  return run;

  //        detectionAppVersion: "6.4.5", // 1.0
  //        detectionAppOs: "windows", // macos
};
